//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DetailsItem',
  props: {
    label: { type: [String, Number], default: '' },
    content: { type: [String, Number], default: '' },
    emptyText: { type: String, default: '暫不提供' },
  },
};
